<mat-form-field id="dateCOMP-form" [formGroup]="group" class="custom-form-field">
  <mat-label>{{ field.displayName }}</mat-label>
  <input
    matInput
    [matDatepicker]="picker"
    [formControlName]="field.name"
    [name]="field.name"
    [ngModel]="field.value"
    (click)="picker.open()"
    readonly
    [max]="maxDate"
    [min]="minDate"
  />
  <mat-datepicker-toggle id="dateCOMP-form-datepicker" matSuffix [for]="picker">
    <mat-icon id="dateCOMP-form-icon" matDatepickerToggleIcon>
      <img id="dateCOMP-form-img" src="assets/images/icons/default_icons/icon-calendar.png" alt="icon" />
    </mat-icon>
  </mat-datepicker-toggle>
  <mat-datepicker id="dateCOMP-form-date" #picker touchUi></mat-datepicker>
  <mat-hint></mat-hint>
  <ng-container id="dateCOMP-form-ng-container1" *ngFor="let validation of field.validations" ngProjectAs="mat-error">
    <mat-error id="dateCOMP-form-matERROR{{ field.name }}" *ngIf="group.get(field.name).hasError(validation.name)">{{
      validation.message
    }}</mat-error>
  </ng-container>
</mat-form-field>
